'use client';

import { createContext, useContext } from 'react';
import type { ListingImportQueueItem } from '../types/listing-import-queue-item';
export interface ListingImportContextValue {
  queue: ListingImportQueueItem[];
  isUploading: boolean;
  startImport: (files: File[], orgId: string) => Promise<void>;
}
export const ListingImportContext = createContext<ListingImportContextValue | null>(null);
export function useListingImport(): ListingImportContextValue {
  const value = useContext(ListingImportContext);
  if (!value) {
    throw new Error('useListingImport must be used within ListingImportProvider');
  }
  return value;
}